<template>
	<div id="student-marks">
		<!-- update mark dialog -->
		<v-dialog v-model="dialog" max-width="600" :persistent="submitLoading">
			<v-form ref="form" :disabled="submitLoading" @submit.prevent="submit">
				<v-card>
					<v-card-title class="justify-space-between">
						<span>تعديل بيانات المادة</span>
						<v-btn icon small @click="dialog = false">
							<v-icon>$close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<!-- student -->
						<v-card outlined class="mb-4">
							<v-card-title class="pt-2 pb-0 justify-space-between">
								<span>{{student.name}}</span>
								<v-chip
									v-if="false"
									small
									color="green darken-1"
									text-color="white"
									class="px-2"
								>
									<v-icon size="18" class="me-1">$check</v-icon>
									حاضر
								</v-chip>
							</v-card-title>
							<v-card-text class="pb-2">
								{{getConceptById(conceptId)?.name}} / {{subjectBreadcrumb}}
							</v-card-text>
						</v-card>
				
						<!-- data -->
						<v-card outlined>
							<v-card-text class="pa-2">
								<v-row dense>
									<!-- is attended -->
									<v-col cols="12" class="pa-2">
										<v-checkbox
											v-model="dialogData.isAttended"
											label="حضر/ت الامتحان"
											class="mt-0 pt-0"
											hide-details
											@change="!$event ? dialogData.mark = 0 : null"
										/>
									</v-col>
									
									<!-- date -->
									<v-col sm="6" cols="12" class="pa-2">
										<v-menu
											ref="menu"
											disabled
											:close-on-content-click="false"
											:nudge-right="40"
											transition="scale-transition"
											offset-y
											min-width="auto"
										>
											<template v-slot:activator="{ on, attrs }">
												<v-text-field
													v-model="dialogData.date"
													label="تاريخ الاختبار"
													append-icon="$calendar"
													readonly
													outlined
													dense
													hide-details
													v-bind="attrs"
													v-on="on"
													:rules="rules.required"
												></v-text-field>
											</template>
											<v-date-picker
												v-model="dialogData.date"
												@input="$refs.menu.save()"
											></v-date-picker>
										</v-menu>
									</v-col>
									
									<!-- mark -->
									<v-col sm="6" cols="12" class="pa-2">
										<!-- mark -->
										<v-text-field
											v-if="!dialogData.scales.length"
											v-model.number="dialogData.mark"
											label="العلامة المستحقة (رقماً)"
											type="number"
											hide-spin-buttons
											:prefix="
												typeof dialogData.maxMark === 'number'
													? `${dialogData.maxMark}/`
													: ''
											"
											outlined
											dense
											:disabled="!dialogData.isAttended"
											hide-details
											:rules="[
												...rules.requiredAsNumber,
												val => dialogData.maxMark ? (val <= dialogData.maxMark) : true
											]"
										></v-text-field>

										<!-- scale mark -->
										<v-autocomplete
											v-else
											v-model.number="dialogData.mark"
											:items="dialogData.scales"
											label="العلامة المستحقة"
											:prefix="dialogData.scales[dialogData.scales.length - 1].code + ' /'"
											item-text="code"
											item-value="orderIndex"
											outlined
											dense
											:disabled="!dialogData.isAttended"
											hide-details
											:rules="[
												...rules.requiredAsNumber,
												val => val <= dialogData.scales[dialogData.scales.length - 1].orderIndex
											]"
										></v-autocomplete>
									</v-col>

									<!-- notes -->
									<v-col cols="12" class="pa-2">
										<v-textarea
											v-model="dialogData.notes"
											label="ملاحظات"
											outlined
											hide-details
											rows="3"
											auto-grow
										/>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-card-text>
					<v-card-actions class="justify-end">
						<v-btn
							depressed
							color="primary"
							type="submit"
							:loading="submitLoading"
						>
							حفظ
						</v-btn>
						<v-btn depressed :disabled="submitLoading" @click="dialog = false">
							إلغاء
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>

		<!-- top row -->
		<div class="d-flex flex-wrap flex-sm-row flex-column-reverse align-sm-center">
			<!-- breadcrumbs -->
			<bee-breadcrumbs
				:items="[
					{
						to: {
							name: 'marks',
							params: {
								classId: $route.params.classId,
								courseId: $route.params.courseId,
							},
							query: { conceptId: $route.query.conceptId }
						},
						disabled: false,
						icon: 'mdi-bookshelf',
						text: 'العلامات'
					},
					{
						disabled: true,
						text: student.name
					},
				]"
				class="mt-sm-0 mt-3"
			/>

			<v-spacer/>
			
			<!-- buttons -->
			<div class="d-flex flex-wrap justify-sm-end align-center">
				<!--print-->
				<v-btn
					outlined
					height="30"
					class="mx-3"
					:disabled="loading || submitLoading"
					@click="generateConceptReport"
				>
					<v-icon class="me-2">$printer</v-icon>
					تقرير concept
				</v-btn>
				
				<!-- add -->
				<v-btn
					color="primary"
					depressed
					height="30"
					:to="{
						name: 'update-student-marks',
						params: {
							classId: $route.params.classId,
							studentId: $route.params.studentId
						},
						query: { conceptId: $route.query.conceptId }
					}"
				>
					<v-icon class="me-2">$add</v-icon>
					تحديث العلامات
				</v-btn>
			</div>
		</div>

		<v-divider class="my-3"/>

		<!-- show -->
		<div class="d-flex flex-wrap justify-space-between align-center mb-2">
			<!-- show for -->
			<div class="d-flex flex-wrap align-center" style="max-width: 100%;">
				<span class="me-1 text-no-wrap">عرض بيانات: </span>
				<v-chip-group
					v-model="conceptId"
					color="primary"
					class="d-flex align-center"
					show-arrows
					center-active
					mandatory
					@change="$router.replace({ query: { ...$route.query, conceptId } })"
				>
					<v-chip
						v-for="item in concepts"
						:key="item.id"
						small
						:value="item.id"
						:disabled="loading"
						class="my-0"
					>
						{{item.name}}
					</v-chip>
				</v-chip-group>
			</div>

			<!-- show as -->
			<!-- showMarksAs is hidden for current version only -->
			<div v-if="false" class="d-flex flex-wrap align-center">
				<span class="me-1 text-no-wrap">عرض العلامات حسب: </span>
				<v-radio-group
					v-model="showMarksAs"
					row
					hide-details
					class="mt-0"
					@change="$router.replace({ query: { ...$route.query, showMarksAs } })"
				>
					<v-radio
						label="الكل"
						:value="1"
						color="green"
						:ripple="false"
					/>
					<v-radio
						label="الحضور"
						:value="2"
						color="green"
						:ripple="false"
					/>
					<v-radio
						label="الغياب"
						:value="3"
						color="green"
						:ripple="false"
					/>
				</v-radio-group>
			</div>
		</div>

		<!-- loading -->
		<div
			v-if="loading"
			class="fill-height d-flex justify-center align-center"
			:style="`height:${$vuetify.breakpoint.height - 200}px`"
		>
			<v-progress-circular
				color="primary"
				size="40"
				indeterminate
			/>
		</div>
		
		<div v-else>
			<!-- table -->
			<bee-handy-table
				:headers="headers"
				:items="flattedRows"
				dense
				zebra
				fixed-header
				hide-default-footer
				:items-per-page="-1"
				shown-rows-text
				with-columns-divider
				table-class="overflow-hidden"
				:data-table-props="{
					disableSort: true,
					noDataText: 'لا توجد بيانات متاحة، يرجى التأكد من وجود امتحان واحد على الأقل',
				}"
			>
				<!-- :height="$vuetify.breakpoint.height - 180" -->
				<template v-slot:item="{ item, index }">
					<tr
						:class="
							index % 2 === 1
								? getConcept(item.subjectGroupId, 'colorClass') + '-light'
								: 'bee-handy-table--zebra-color'
						"
					>
						<template v-for="(header, i) in headers">
							<!-- subjectGroupId -->
							<template v-if="header.name === 'subjectGroupId'">
								<td
									v-if="index === 0 || flattedRows[index - 1]?.subjectGroupId !== item.subjectGroupId"
									:class="[
										...getBindRowClass(header),
										getConcept(item.subjectGroupId, 'colorClass')
									]"
									:rowspan="getConcept(item.subjectGroupId, 'subRows').length"
									:key="i"
								>
									<div class="d-inline-flex pb-1 text-no-wrap rotate-header-90">
										{{item.subjectGroupName}}
									</div>
								</td>
							</template>

							<!-- attendance -->
							<td
								v-else-if="header.name === 'attendance'"
								:key="i"
								:class="getBindRowClass(header)"
							>
								<v-chip
									v-if="typeof item.attendance === 'boolean'"
									small
									class="rounded-sm white--text"
									:color="item.attendance ? 'green darken-1' : 'error'"
								>
									<v-icon size="18" class="me-2">
										{{item.attendance ? '$check' : '$falseCheck'}}
									</v-icon>
									{{item.attendance ? 'حاضر' : 'غائب'}}
								</v-chip>
								<span v-else>-</span>
							</td>

							<!-- actions -->
							<td
								v-else-if="header.name === 'actions'"
								:key="i"
								:class="getBindRowClass(header)"
							>
								<v-btn
									v-if="typeof item.markId === 'number'"
									icon
									small
									color="primary"
									@click="editMarkId = item.markId; dialog = true;"
								>
									<v-icon size="22">$edit</v-icon>
								</v-btn>
							</td>
							
							<!-- other headers -->
							<td
								v-else
								:key="i"
								:class="getBindRowClass(header)"
							>
								{{item[header.value] || '-'}}
							</td>
						</template>
					</tr>
				</template>
			</bee-handy-table>

			<!-- marks chart -->
			<!-- charts is hidden for current version only -->
			<v-card v-show="false" outlined class="mt-6">
				<v-card-title class="pt-3 pb-0">مخطط عرض بينات الطالب بالنسبة للـ Concept</v-card-title>
				<v-card-text class="px-0 pb-0">
					<apexchart
						type="bar"
						:height="$vuetify.breakpoint.height * 0.65"
						:options="getChartOptions({ rotateAlways: true, colors: marksChartColors })"
						:series="[{ name: 'الدرجة', data: marksData }]"
					/>
				</v-card-text>
			</v-card>

			<!-- concept chart -->
			<!-- charts is hidden for current version only -->
			<v-card v-show="false" outlined class="mt-6">
				<v-card-title class="pt-3 pb-0">
					مخطط عرض بيانات الـ Cocept بالنسبة للعلامات (بالرموز)
				</v-card-title>
				<v-card-text class="px-0 pb-0">
					<apexchart
						type="bar"
						:height="$vuetify.breakpoint.height * 0.4"
						:options="getChartOptions({ colors: Array.from({ length: conceptMarks.length }).fill(baseColors[0]) })"
						:series="[{ name: 'الدرجة', data: conceptMarks }]"
					/>
				</v-card-text>
			</v-card>
		</div>
	</div>
</template>

<script>
import rules from '@/helpers/validation-rules';
import printJS from 'print-js';
import { generateExamReport } from '@/helpers/generate-html';
import { mapGetters } from 'vuex';
import moment from 'moment';
import { fixNumber, generateResultOptionsData, getLateralGrade } from '@/helpers/functions';

export default {
	name: 'StudentMarks',

	data: () => ({
		// helpers
		showMarksAs: 1,
		baseColors: ['#3570b6bd', '#866df2bd', '#18a503bd', '#fc5e33bd', '#fa0a78bd', '#7a4269bd'],
		rules,

		loading: false,
		submitLoading: false,

		courseId: null,
		conceptId: null,

		subjectRows: [],

		// dialog
		editMarkId: null,
		subjectBreadcrumb: '',

		dialog: false,
		dialogData: {
			isAttended: null,
			date: null,
			mark: null,
			maxMark: null,
			notes: null,
			scales: []
		},

		// charts
		marksData: [], // [{ x: 'subject', y: number between 1 - 5 }]
		conceptMarks: [], // [{ x: 'subject', y: number between 1 - 5 }]

		// data
		concepts: [],
		student: {},
	}),

	watch: {
		dialog(val) {
			if (val) {
				if (typeof this.editMarkId === 'number') {
					const row = this.flattedRows.find(c => c.markId === this.editMarkId);
					if (row) {
						this.subjectBreadcrumb =
							`${row.subjectGroupName} / ${row.subjectName} / الاختبار ${row.examName}`;
							
						this.dialogData.isAttended =
							typeof row.attendance === 'boolean' ? row.attendance : true;
						this.dialogData.date = row.examDate;
						this.dialogData.mark = row.mark;
						this.dialogData.maxMark = row.maxMark;
						this.dialogData.notes = row.notes;
						this.dialogData.scales = row.scales || [];
					}
				}
			} else {
				this.dialogData.isAttended = true;
				this.dialogData.date = null;
				this.dialogData.mark = null;
				this.dialogData.maxMark = null;
				this.dialogData.notes = null;
				this.dialogData.scales = [];
				this.editMarkId = null;
				this.subjectBreadcrumb = '';
				this.$refs.form.resetValidation();
			}
		},

		$route: {
			handler (newVal, oldVal) {
				const oldRoute = oldVal || { params: {}, query: {} };

				this.courseId = +newVal.params.courseId || null;
				this.conceptId = +newVal.query.conceptId || null;
				this.showMarksAs = +newVal.query.showMarksAs || 1;

				if (
					(typeof this.conceptId === 'number' && this.conceptId !== +oldRoute.query.conceptId) ||
					(typeof this.showMarksAs === 'number' && this.showMarksAs !== +oldRoute.query.showMarksAs)
				) {
					this.fetchMarks();
				}
			},
			immediate: true,
			deep: true,
		}
	},

	computed: {
		...mapGetters({
			getConceptById: 'classes/getConceptById',
			getClassById: 'classes/getClassById',
			getCourseById: 'classes/getCourseById',
		}),

		headers() {
			const headers = [
				{
					text: '',
					name: 'subjectGroupId',
					value: 'subjectGroupId',
					width: 40,
				},
				{
					text: 'المادة',
					name: 'subjectName',
					value: 'subjectName',
					width: 200,
					divider: false,
				},
				{
					text: 'التفقد',
					name: 'attendance',
					value: 'attendance',
					width: 120
				},
				{
					text: 'تاريخ الامتحان',
					name: 'examDate',
					value: 'examDate',
					width: 120
				},
				{
					text: 'العلامة المستحقة\n(رقماً)',
					name: 'marksObtained',
					value: 'marksObtained',
					width: 120
				},
				{
					text: 'العلامة المستحقة\n(نسبة مئوية)',
					name: 'marksObtainedPercentage',
					value: 'marksObtainedPercentage',
					width: 120
				},
				{
					text: 'العلامة المستحقة\n(ترميز)',
					name: 'marksObtainedGrade',
					value: 'marksObtainedGrade',
					width: 120
				},
				{
					text: 'ملاحظات',
					name: 'notes',
					value: 'notes',
				},
				{
					text: '',
					name: 'actions',
					value: 'actions',
					width: 30
				}
			];

			for (let i = 0; i < headers.length; i++) {
				headers[i].class = headers[i].class ? headers[i].class + ' color-1' : 'color-1';
				headers[i].columnClass = headers[i].columnClass ? headers[i].columnClass + ' px-2' : 'px-2';
			}
			return headers;
		},

		nestedRows() {
			/* const headers = [
				{
					text: 'Reading',
					id: 'reading',
					subRows: [
						{
							text: 'Reading in phrases',
							name: 'readingInPhrases',
							value: 'readingInPhrases',
						},
						{
							text: 'Pace',
							name: 'pace',
							value: 'pace',
						},
						{
							text: 'Syntax',
							name: 'syntax',
							value: 'syntax',
						},
						{
							text: 'Self-corrections',
							name: 'selfCorrections',
							value: 'selfCorrections',
						},
						{
							text: 'Intonation',
							name: 'intonation',
							value: 'intonation',
						},
						{
							text: 'Letter naming fluency',
							name: 'letterNamingFluency',
							value: 'letterNamingFluency',
						},
						{
							text: 'Slight word fluency',
							name: 'slightWordFluency',
							value: 'slightWordFluency',
						},
						{
							text: 'Comprehension',
							name: 'comprehension',
							value: 'comprehension',
						},
					]
				},
				{
					text: 'Phonics awareness',
					id: 'phonicsAwareness',
					subRows: [
						{
							text: 'Phoneme categorization',
							name: 'phonemeCategorization',
							value: 'phonemeCategorization',
						},
						{
							text: 'Phoneme blending',
							name: 'phonemeBlending',
							value: 'phonemeBlending',
						},
						{
							text: 'Phoneme segmentation',
							name: 'phonemeSegmentation',
							value: 'phonemeSegmentation',
						},
					],
				},
				{
					text: 'Readers to writers',
					id: 'readersToWriters',
					subRows: [
						{
							text: 'Spelling',
							name: 'spelling',
							value: 'spelling',
						},
						{
							text: 'Vocabulary',
							name: 'vocabulary',
							value: 'vocabulary',
						},
						{
							text: 'Ideas and content',
							name: 'ideasAndContent',
							value: 'ideasAndContent',
						},
						{
							text: 'Grammar',
							name: 'grammar',
							value: 'grammar',
						},
						{
							text: 'Structural analysis',
							name: 'structuralAnalysis',
							value: 'structuralAnalysis',
						},
						{
							text: 'Writing',
							name: 'writing',
							value: 'writing',
						},
					],
				},
				{
					text: 'Listening and speaking',
					id: 'listeningAndSpeaking',
					subRows: [
						{
							text: 'Interactive read aloud',
							name: 'interactiveReadAloud',
							value: 'interactiveReadAloud',
						},
						{
							text: 'Retelling cards',
							name: 'retellingCards',
							value: 'retellingCards',
						},
					],
				},
				{
					text: 'Social and study skills',
					id: 'socialAndStudySkills',
					subRows: [
						{
							text: 'Participation',
							name: 'participation',
							value: 'participation',
						},
						{
							text: 'Completion of work',
							name: 'completionOfWork',
							value: 'completionOfWork',
						},
						{
							text: 'Concentration',
							name: 'concentration',
							value: 'concentration',
						},
						{
							text: 'Self direction',
							name: 'selfDirection',
							value: 'selfDirection',
						},
						{
							text: 'Cooperation with others',
							name: 'cooperationWithOthers',
							value: 'cooperationWithOthers',
						},
						{
							text: 'Behavior',
							name: 'behavior',
							value: 'behavior',
						},
						{
							text: 'Presentation of assignments',
							name: 'presentationOfAssignments',
							value: 'presentationOfAssignments',
						},
					],
				},
				{
					text: 'Movement video',
					id: 'movementVideo',
					subRows: [
						{
							text: null,
							name: 'movementVideo',
							value: 'movementVideo',
							noRotate: true
						}
					]
				}
			]; */

			const headers = this.subjectRows;

			for (let i = 0; i < headers.length; i++) {
				headers[i].columnClass = headers[i].columnClass ? headers[i].columnClass + ' px-0' : 'px-0';
				headers[i].colorClass = `color-${((i) % 6) + 1}`;
				headers[i].align = 'center';
			}
			return headers;
		},

		flattedRows() {
			const flattedRows = this.nestedRows.flatMap(header => {
				if (header.subRows) {
					return header.subRows.map(child => ({
						subjectGroupId: header.id,
						subjectGroupName: header.text,
						...child,
					}))
				}
				return header;
			});

			// generate values
			const items = flattedRows.flatMap(row => {
				return this.headers.reduce((res, a, i, arr) => {
					if (!(a.value in res) && i !== arr.length - 1) {
						res[a.value] = row[a.value];
					}
					return { ...row, ...res };
				}, {
					subjectGroupId: row.subjectGroupId,
					subjectGroupName: row.subjectGroupName,
					subjectName: row.text,
				})
			})
			
			return items;
		},

		marksChartColors() {
			const colors = []
			this.nestedRows.forEach((row, i) => {
				if (row.subRows) {
					row.subRows.forEach(() => {
						colors.push(this.baseColors[i % this.baseColors.length])
					})
				}
			})
			return colors;
		},
	},

	methods: {
		getConcept(subjectGroupId, propSearch = null) {
			const concept = this.nestedRows.find(c => c.id === subjectGroupId)
			if (concept) {
				if (propSearch) return concept[propSearch] || null;
				return concept;
			}
			return {};	
		},

		getBindRowClass(header) {
			return [
				header.cellClass,
				header.columnClass,
				{ 'v-data-table__divider': header.divider },
				`text-${header.align || 'start'}`,
			]
		},

		getChartOptions({ rotateAlways, colors } = {}) {
			return {
				chart: {
					fontFamily: 'Fairuz, Arial, sans-serif',
					toolbar: {
						show: false,
						tools: {
							download: true,
							selection: true,
							zoom: true,
							zoomin: true,
							zoomout: true,
							pan: true,
							reset: true
						},
					},
					// height: 450,
					type: 'bar',
					events: {
						click: function (chart, w, e) {
							// console.log(chart, w, e)
						},
					},
				},
				colors: colors || [],
				plotOptions: { bar: { columnWidth: '45%', distributed: true, borderRadius: 5, borderRadiusApplication: 'end' } },
				dataLabels: { enabled: false },
				legend: { show: false },
				xaxis: {
					type: 'category',
					labels: {
						rotate: -90,
						rotateAlways: rotateAlways || false,
						maxHeight: 180,
						trim: false,
						style: {
							colors: colors.map(c => c.length > 7 ? c.slice(0, 7) : c) || [],
							fontSize: '14px',
						},
					},
				},
				yaxis: {
					labels: {
						formatter: val => ['NI', 'F', 'G', 'VG', 'Ex'][val] || '',
						style: {
							fontSize: '12px',
						}
					}
				},
				tooltip: {
					x: { show: false },
					y: { formatter: (val) => ['Need Improvement', 'Fail', 'Good', 'Very Good', 'Excellent'][val] || '' }
				}
			}
		},

		generateConceptReport() {
			const data = this.subjectRows
				.filter(c => c.subRows.some(e => typeof e.markId === 'number'))
				.map(c => ({
					subject: c.text,
					children:
						c.subRows.filter(e =>
							typeof e.markId === 'number' &&
							typeof e.mark === 'number'
						).map(e => ({
							subject: e.text,
							attendance: e.attendance,
							numeralMark: e.mark,
							mark: e.attendance
								? !e.scales.length
									? getLateralGrade(e.markPercentage || 0).num
									: e.scales.find(t => t.orderIndex === e.mark)?.orderIndex ??
										getLateralGrade(e.markPercentage || 0).num
								: -1,
							maxMark: e.maxMark,
							scales: e.scales.map(c => c.code),
							includeInResults: e.includeInResults, 
							isManualCorrect: e.isManualCorrect, 
						}))
				}));
			
			const html = generateExamReport(data, {
				headerText: `
					Name: ${this.student.name}
					${'&nbsp;'.repeat(2)}
					Class: ${this.getClassById(+this.$route.params.classId).name}
					${'&nbsp;'.repeat(2)}
					Section: ${this.getCourseById(+this.$route.params.courseId)?.title ?? ''}
					${'&nbsp;'.repeat(2)}
					School Year: 2025-2026
					${'&nbsp;'.repeat(10)}
					${this.getConceptById(this.conceptId)?.name} / ${this.concepts.length}
				`,
				...generateResultOptionsData(data)
			});

			printJS({ printable: html, type: 'raw-html' });
		},

		// fetch
		fetchClassData() {
			return this.$store.dispatch('classes/fetchClassData', {
				classId: this.$route.params.classId
			}).then(({ concepts }) => {
				this.concepts = concepts;
			})
		},

		fetchSubjects(data) {
			if (!this.$route.params.courseId) return;
			let promise;

			const getMainData = subjectId => data.find(c => c.subjectId === subjectId) || {};
			
			if (!this.subjectRows.length) {
				promise = this.$store.dispatch('subjects/fetchByClassId', {
					classId: this.$route.params.classId
				}).then(data => {
					this.subjectRows = data.map(c => ({
						id: c.id,
						text: c.name,
						subRows: c.subjectChilds.map(e => ({
							text: e.name,
							...getMainData(e.id),
						}))
					}));
				})
			} else {
				this.subjectRows = this.subjectRows.map(c => ({
					id: c.id,
					text: c.text,
					subRows: c.subRows.map(e => ({
						text: e.text,
						...getMainData(e.subjectId),
					}))
				}));
				promise = Promise.resolve();
			}

			return promise;
		},

		async fetchMarks(preventLoading = false) {
			if (!this.$route.params.courseId) return;
			
			this.loading = !preventLoading;

			try {
				let data = { student: {}, examTest: [] };
				await Promise.all([
					this.fetchClassData(),
					this.$store.dispatch('marks/fetchStudentMarks', { 
						studentId: this.$route.params.studentId,
						courseId: this.courseId,
						conceptId: this.conceptId,
						isAbsent: this.showMarksAs === 1 ? null : this.showMarksAs === 3,
					}).then(marksData => {
						data =
							Object.keys(marksData).length
								? marksData
								: { student: { username: 'الطالب' }, examTest: [] };
					})
				])
				this.student = {
					id: data.student.id,
					name: data.student.username,
					marksData: data.examTest.flatMap(examTest => 
						(examTest.examGrades || []).map(c => {
							const markPercentage =
								c.grade ? fixNumber((c.grade.mark / (c.topicMaxMark || 1)) * 100, 2) : null;
							return {
								examName: data.examTest[0].name,
								markId: c.examTopicId,
								subjectId: c.topic.id,
								subjectName: c.topic.name,
								subjectGroupName: c.topic.parent.name,
								mark: c.grade ? c.grade.mark : null,
								maxMark: c.topicMaxMark,
								markPercentage,
								includeInResults: c.topic.includeInExamTestResult,
								isManualCorrect: c.topic.isManuallyCorrected,
								scales: (c.topic.scales || []).sort((a, b) => a.orderIndex - b.orderIndex),
								attendance: c.grade ? !c.grade.isAbsent : null,
								examDate: examTest.date ? moment(examTest.date).format('YYYY-MM-DD') : null,
								marksObtained: c.grade ? `${c.grade.mark} \\ ${c.topicMaxMark || '?'}` : null,
								marksObtainedPercentage: c.grade ? markPercentage + '%' : null,
								marksObtainedGrade:
									c.grade
										? !c.topic.scales.length
											? getLateralGrade(markPercentage || 0).code
											: c.topic.scales.find(e => e.orderIndex === c.grade.mark)?.code ??
												getLateralGrade(markPercentage || 0).code
										: null,
								notes: c.grade ? c.grade.notes : null,
							}
						})
					)
				};
				
				await this.fetchSubjects(this.student.marksData);
			} catch (e) {
				console.error(e);
			} finally {
				this.loading = false;
			}
		},

		submit() {
			if (this.$refs.form.validate()) {
				this.submitLoading = true;
				this.$store.dispatch('marks/update', {
					examTopicId: this.editMarkId,
					studentId: +this.$route.params.studentId,
					mark: this.dialogData.mark,
					notes: this.dialogData.notes,
					date: this.dialogData.date,
					isAbsent: !this.dialogData.isAttended,
				}).then(() => {
					// local row update
					const row = this.flattedRows.find(c => c.markId === this.editMarkId);
					const markPercentage =
						row.maxMark ? fixNumber((this.dialogData.mark / (row.maxMark || 1)) * 100, 2) : null;
					row.attendance = this.dialogData.isAttended;
					row.mark = this.dialogData.mark;
					row.markPercentage = markPercentage;
					row.examDate = moment(this.dialogData.date).format('YYYY-MM-DD');
					row.marksObtained = `${this.dialogData.mark} \\ ${row.maxMark || '?'}`;
					row.marksObtainedPercentage = markPercentage + '%';
					row.marksObtainedGrade = 
						!row.scales.length
							? getLateralGrade(markPercentage || 0).code
							: row.scales.find(e => e.orderIndex === this.dialogData.mark)?.code ??
								getLateralGrade(markPercentage || 0).code
					row.notes = this.dialogData.notes;

					// update actual data
					this.fetchMarks(true);

					this.$snackbar.info('تم تحديث العلامة بنجاح');
					this.dialog = false;
				}).finally(() => {
					this.submitLoading = false;
				})
			}
		}
	},

	created() {
		this.$store.dispatch('classes/fetchClassData', {
			classId: this.$route.params.classId,
		});

		this.marksData = this.flattedRows.map(c => ({
			x: c.subjectName || c.subjectGroupName,
			y: Math.floor(Math.random() * 5),
		}));

		for (let i = 1; i <= 12; i++) {	
			this.conceptMarks.push({
				x: 'concept ' + i,
				y: Math.floor(Math.random() * 5),
			})
		}
	}
}
</script>

<style lang="scss">
#student-marks {
	.v-data-table-header th {
		white-space: pre-line;
	}
}
</style>